// extracted by mini-css-extract-plugin
module.exports = {"bottomNavigation":"styles_bottomNavigation__2uoxM","navItem":"styles_navItem__IJpk4","selected":"styles_selected__3tXbv"};